export const setPopular = (restaurants) => ({
    type: 'SET_POPULAR',
    restaurants
});